// Specialty item money stays in cents, the unit the catalog stores, so line
// totals and tax are integer arithmetic and cannot drift. Callers convert to
// dollars only to display or to merge into the order totals.
//
// taxRate is the fraction held in formData.provisional_tax_rate (0.13), not a
// percent.

export const lineTotalCents = (line) =>
  Number(line?.unit_price || 0) * Number(line?.quantity || 0);

// Rounded per line, never once over the subtotal. This mirrors bps-go: two lines
// of a 333c item at 13% are 43 + 43 = 86, where rounding 666c once gives 87.
export const lineTaxCents = (line, taxRate) =>
  line?.taxable ? Math.round(lineTotalCents(line) * Number(taxRate || 0)) : 0;

export const specialtyItemTotalsCents = (lines = [], taxRate = 0) =>
  lines.reduce(
    (totals, line) => ({
      amount: totals.amount + lineTotalCents(line),
      tax: totals.tax + lineTaxCents(line, taxRate),
    }),
    { amount: 0, tax: 0 }
  );

// The chip counts items sold, not rows: three of one item is three.
export const specialtyItemCount = (lines = []) =>
  lines.reduce((count, line) => count + Number(line?.quantity || 0), 0);

// A row is only ready to order once it names an item and a quantity.
export const isSpecialtyLineComplete = (line) =>
  Boolean(line?.specialty_item_id) && Number(line?.quantity) > 0;
